export default __webpack_public_path__ + "static/media/trial2.13663e58.jpg";